module.exports = __webpack_public_path__ + "img/girl.e131c743.png";